import { useEffect, useState, type RefObject } from 'react';

export function useTight(ref: RefObject<HTMLElement | null>, deps: unknown[] = [], onFit?: () => void) {
  const [tight, setTight] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const fit = () => {
      const was = el.classList.contains('is-tight');
      el.classList.remove('is-tight');
      el.classList.add('fit-measuring');
      const over = el.scrollWidth > el.clientWidth + 1;
      el.classList.remove('fit-measuring');
      if (was) el.classList.add('is-tight');
      setTight(over);
      onFit?.();
    };
    fit();
    const ro = new ResizeObserver(fit);
    ro.observe(el);
    window.addEventListener('resize', fit);
    return () => { ro.disconnect(); window.removeEventListener('resize', fit); };
  }, deps);
  return tight;
}
